var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag === 'span')?_c('span',{class:[
        _vm.needClass === false? '': 'cp status',
        _vm.themes? 'is-'+ _vm.themes: '',
        _vm.icon? 'icon-font '+ _vm.icon: '' ]},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_vm._t("default")],2):(_vm.tag === 'div')?_c('div',{class:_vm.classArray},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }